(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('read-more-text')) {
    customElements.define(
      'read-more-text',
      class ReadMoreText extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.read-more-text__content');
          this.button = this.querySelector('.read-more-text__toggle');
          if (!this.content || !this.button) return;

          this.limit = parseInt(this.dataset.words, 10) || 40;
          this.fullHTML = this.content.innerHTML;
          this.truncatedHTML = this.buildTruncatedHTML();

          // Text is shorter than the limit — nothing to collapse.
          if (this.truncatedHTML === null) {
            this.button.hidden = true;
            return;
          }

          this.expanded = false;
          this.render();
          this.button.addEventListener('click', () => {
            this.expanded = !this.expanded;
            this.render();
          });
        }

        // Cuts the rendered rich text after the word limit while keeping the
        // HTML structure (paragraphs, bold, links) intact.
        buildTruncatedHTML() {
          const clone = this.content.cloneNode(true);
          const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);
          let remaining = this.limit;
          let boundary = null;

          while (walker.nextNode()) {
            const node = walker.currentNode;
            const words = node.textContent.split(/\s+/).filter(Boolean);
            if (words.length <= remaining) {
              remaining -= words.length;
              continue;
            }
            node.textContent = words.slice(0, remaining).join(' ') + '…';
            boundary = node;
            break;
          }

          if (!boundary) return null;

          // Drop everything after the cut point, at every level of the tree.
          let node = boundary;
          while (node && node !== clone) {
            while (node.nextSibling) node.nextSibling.remove();
            node = node.parentNode;
          }

          return clone.innerHTML;
        }

        render() {
          this.content.innerHTML = this.expanded ? this.fullHTML : this.truncatedHTML;
          this.button.textContent = this.expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
          this.button.setAttribute('aria-expanded', String(this.expanded));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('read-more-text')) {
    customElements.define(
      'read-more-text',
      class ReadMoreText extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.read-more-text__content');
          this.button = this.querySelector('.read-more-text__toggle');
          if (!this.content || !this.button) return;

          this.limit = parseInt(this.dataset.words, 10) || 40;
          this.fullHTML = this.content.innerHTML;
          this.truncatedHTML = this.buildTruncatedHTML();

          // Text is shorter than the limit — nothing to collapse.
          if (this.truncatedHTML === null) {
            this.button.hidden = true;
            return;
          }

          this.expanded = false;
          this.render();
          this.button.addEventListener('click', () => {
            this.expanded = !this.expanded;
            this.render();
          });
        }

        // Cuts the rendered rich text after the word limit while keeping the
        // HTML structure (paragraphs, bold, links) intact.
        buildTruncatedHTML() {
          const clone = this.content.cloneNode(true);
          const walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);
          let remaining = this.limit;
          let boundary = null;

          while (walker.nextNode()) {
            const node = walker.currentNode;
            const words = node.textContent.split(/\s+/).filter(Boolean);
            if (words.length <= remaining) {
              remaining -= words.length;
              continue;
            }
            node.textContent = words.slice(0, remaining).join(' ') + '…';
            boundary = node;
            break;
          }

          if (!boundary) return null;

          // Drop everything after the cut point, at every level of the tree.
          let node = boundary;
          while (node && node !== clone) {
            while (node.nextSibling) node.nextSibling.remove();
            node = node.parentNode;
          }

          return clone.innerHTML;
        }

        render() {
          this.content.innerHTML = this.expanded ? this.fullHTML : this.truncatedHTML;
          this.button.textContent = this.expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
          this.button.setAttribute('aria-expanded', String(this.expanded));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
